var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-incident-coup-attempt-detail" },
    [
      _c(
        "b-form-group",
        { attrs: { label: "A) " + _vm.$t("coup_attempt_type") } },
        [
          _vm.getCoupAttemptTypeNames.length ||
          _vm._.get(_vm.entity, "other_coup_attempt")
            ? _c(
                "div",
                [
                  _vm._l(_vm.getCoupAttemptTypeNames, function(
                    typeName,
                    index
                  ) {
                    return _c("span", { key: index }, [
                      _vm._v(" " + _vm._s(typeName)),
                      index < _vm.getCoupAttemptTypeNames.length - 1 ||
                      _vm._.get(_vm.entity, "other_coup_attempt")
                        ? _c("span", [_vm._v(", "), _c("br")])
                        : _vm._e()
                    ])
                  }),
                  _vm._.get(_vm.entity, "other_coup_attempt")
                    ? _c("span", [
                        _vm._v(
                          " Outro: " +
                            _vm._s(
                              _vm._.get(_vm.entity, "other_coup_attempt")
                            ) +
                            " "
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            : _c("div", [_vm._v("-")])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "B) " + _vm.$t("incident_form_date_coup_attempt") } },
        [
          _c("div", [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "incident_date_fmt") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "C) " + _vm.$t("incident_form_unit") } },
        [
          _c("div", [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "legal_entity.name") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "D) " + _vm.$t("incident_form_description_coup_attempt")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "description") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "E) " +
              _vm.$t("incident_form_who_reported_coup_attempt") +
              _vm.$t("incident_form_name_tel_email")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "who_reported") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "F) " +
              _vm.$t("incident_form_responsible_unit") +
              _vm.$t("incident_form_name_tel_email")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "responsible_unit") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "G) " + _vm.$t("incident_form_how_identified") } },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "how_identified") || "-"))
          ])
        ]
      ),
      _vm.getGeneralAttachments.length
        ? _c(
            "b-form-group",
            { attrs: { label: _vm.$t("incident_form_attachments") } },
            [
              _c(
                "b-list-group",
                _vm._l(_vm.getGeneralAttachments, function(file, idx) {
                  return _c(
                    "b-list-group-item",
                    {
                      key: idx,
                      staticClass:
                        "d-flex justify-content-between align-items-center"
                    },
                    [
                      _c("div", [
                        _c("i", {
                          staticClass:
                            "feather icon-file-text text-primary mr-2"
                        }),
                        _vm.getDownloadUrl(file)
                          ? _c(
                              "a",
                              {
                                staticClass: "mr-2 download-link text-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(file),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", [_vm._v(_vm._s(_vm.getFileName(file)))]),
                        _vm.getFileSize(file)
                          ? _c("small", { staticClass: "ml-2 text-muted" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(_vm.getFileSize(file))
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }